import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import { Maximize, Minimize } from 'react-feather';
import { useTranslation } from 'react-i18next';

const FullScreenToggle = () => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const { t } = useTranslation();

  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  const handleFullScreen = () => {
    if (!isFullScreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      }
      setIsFullScreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      setIsFullScreen(false);
    }
  };

  // Listen for fullscreen change to update state
  React.useEffect(() => {
    const handleChange = () => {
      setIsFullScreen(
        !!(
          document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement
        )
      );
    };
    document.addEventListener('fullscreenchange', handleChange);
    document.addEventListener('webkitfullscreenchange', handleChange);
    document.addEventListener('mozfullscreenchange', handleChange);
    document.addEventListener('MSFullscreenChange', handleChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleChange);
      document.removeEventListener('webkitfullscreenchange', handleChange);
      document.removeEventListener('mozfullscreenchange', handleChange);
      document.removeEventListener('MSFullscreenChange', handleChange);
    };
  }, []);

  return (
    <li>
      <div
        className={`mode ${isFullScreen ? 'active' : ''}`}
        onClick={handleFullScreen}
        id="FullScreenTooltip"
        style={{ cursor: 'pointer' }}
      >
        {isFullScreen ? <Minimize size={18} /> : <Maximize size={18} />}
      </div>
      <Tooltip
        placement="left"
        isOpen={tooltipOpen}
        target="FullScreenTooltip"
        toggle={toggleTooltip}
      >
        <strong>
          {isFullScreen ? t('Exit Full Screen') : t('Enter Full Screen')}
        </strong>
      </Tooltip>
    </li>
  );
};

export default FullScreenToggle;